import {CircleNode, CircleNodeModel, h} from '@logicflow/core';
import {resolveExecStyle} from '../../../exec-status';

// 自定义开始节点（圆形）
class StartNode extends CircleNode {
  getShape() {
    const {model} = this.props;
    const {x, y, r, properties} = model;
    const colors = resolveExecStyle(properties, {
      fill: '#F6FFED',
      stroke: '#52C41A',
      text: '#52C41A',
      icon: '#52C41A',
    });

    const triangleIcon = h('svg', {
      x: x - 12,
      y: y - 12,
      width: 24,
      height: 24,
      viewBox: '0 0 1024 1024',
      fill: colors.icon,
    }, [
      h('polygon', {
        points: '256,128 768,512 256,896',
      }),
    ]);

    return h('g', {}, [
      h('circle', {
        cx: x,
        cy: y,
        r,
        fill: colors.fill,
        stroke: colors.stroke,
        strokeWidth: 2,
      }),
      triangleIcon,
    ]);
  }
}

// 自定义开始节点模型
class StartNodeModel extends CircleNodeModel {
  initNodeData(e) {
    super.initNodeData(e);
    this.r = 30; // 设置圆形节点的半径
    if (!this.properties || Object.keys(this.properties).length == 0) {
      this.properties = {
        name: '开始',
        status: '已发起',
      };
    }
  }

  getTools() {
    return [];
  }

  getProps() {
    return [{
      key: 'executor-type',
      label: '发起人',
      control: 'Select',
      option: {
        options: ['固定', '发起人自选'],
        defaultTo: '固定',
      },
      group: '创建',
    }];
  }

  // 限制节点的连接逻辑：只能连出，不能连入
  setAllowLinkIn() {
    return false; // 禁止进入的连线
  }

  setAllowLinkOut() {
    return true; // 允许输出连线
  }
}

export default {
  type: 'start_node',
  view: StartNode,
  model: StartNodeModel,
};
